import { useCallback, useEffect, useState } from "react"
import { Link } from "react-router-dom"
import GuardianIcon from "@/components/common/GuardianIcon"
import { getDailyQuests } from "@/api/gameApi"
import { getGameApiErrorMessage } from "@/api/gameApiErrors"
import { USE_MOCK_BATTLE } from "@/constants/guardians"
import { DailyQuestsResponse } from "@/types/gameMeta"

type Props = {
  refreshKey?: number
}

export default function HomeQuestsTile({ refreshKey = 0 }: Props) {
  const [data, setData] = useState<DailyQuestsResponse | null>(null)

  const load = useCallback(async () => {
    if (USE_MOCK_BATTLE) {
      setData({
        quests: [
          {
            questKey: "DAILY_QUIZ",
            title: "Викторина",
            completed: true,
            claimed: false,
            rewardCoins: 50,
            rewardChakra: 0,
          },
        ],
      })
      return
    }
    try {
      setData(await getDailyQuests())
    } catch (e) {
      if (import.meta.env.DEV) {
        console.warn("[home-quests]", getGameApiErrorMessage(e))
      }
    }
  }, [])

  useEffect(() => {
    void load()
  }, [load])

  useEffect(() => {
    if (refreshKey > 0) void load()
  }, [refreshKey, load])

  const quests = data?.quests ?? []
  const done = quests.filter((q) => q.completed || q.claimed).length
  const claimable = quests.filter((q) => q.completed && !q.claimed).length

  return (
    <Link
      to="/play/daily-quests"
      className="flex w-full flex-row items-center gap-2.5 rounded-2xl border border-sky-400/30 bg-sky-400/[0.06] p-3.5"
    >
      <GuardianIcon name="quests" size={52} />
      <div className="min-w-0 flex-1">
        <div className="text-[11px] font-bold uppercase tracking-wide text-sky-400">
          Задания
        </div>
        <div className="text-[15px] font-extrabold text-white">
          {quests.length > 0 ? `${done} / ${quests.length}` : "На сегодня"}
        </div>
        <div className="text-xs font-semibold text-white/55">
          {claimable > 0 ? `Забрать ${claimable}` : "Ежедневные"}
        </div>
      </div>
      <span className="text-lg text-white/35">›</span>
    </Link>
  )
}
